import { Link } from "react-router-dom";

const base =
    "group inline-flex min-h-[56px] items-center justify-center gap-3 rounded-full px-9 text-[13px] font-bold uppercase tracking-[0.22em] transition-all duration-300 ease-out";

const primary = `${base} bg-celestial-gold text-ink hover:-translate-y-0.5 hover:shadow-[0_8px_40px_rgba(217,179,108,0.35)] active:translate-y-0`;

const secondary = `${base} border border-celestial-blue/50 text-celestial-blue hover:-translate-y-0.5 hover:border-celestial-blue hover:bg-celestial-blue/10 active:translate-y-0`;

function Inner({ to, href, onClick, testid, children, className, style }) {
    const cls = `${className} ${style}`;
    if (to)
        return (
            <Link to={to} data-testid={testid} className={cls}>
                {children}
            </Link>
        );
    if (href)
        return (
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={testid}
                className={cls}
            >
                {children}
            </a>
        );
    return (
        <button type="button" onClick={onClick} data-testid={testid} className={cls}>
            {children}
        </button>
    );
}

export function PrimaryCTA(props) {
    return <Inner {...props} style={primary} />;
}

export function SecondaryCTA(props) {
    return <Inner {...props} style={secondary} />;
}
